<template>
  <div>
    111
  </div>
</template>

<script>
export default {
  name: 'vip',
  data () {
    return {
      token: ''
    }
  },
  created () {
    console.log(this.$route.params.token)
  },
  methods: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/hipc/vip.vue